import React from 'react';
import ReactDOM from 'react-dom/client';
import './lib/ipadReaderBridge';
import './App.css';
import App from './App';
import { ToastProvider } from './components/ui/toast';
import { AppStateBackupProgressProvider } from './components/shared/AppStateBackupProgressOverlay';
// Enable brand-v2 gate on document root for app-wide styling
document.documentElement.classList.add('brand-v2')

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ToastProvider>
      <AppStateBackupProgressProvider>
        <App />
      </AppStateBackupProgressProvider>
    </ToastProvider>
  </React.StrictMode>
);
